import Style from './index.module.less'
import classNames from 'classnames'
import MeToolTip from '../MeToolTip'
import { useTranslation } from 'react-i18next'
import { isEmptyOrNil } from '@/utils'
import MeCountUp from '../CountUp'
const needScrollKey = [
  'totalLiquidity',
  'rollAppCountTotalTransitionHub', // 交易次数
  'totalStakeAndRegionNumtotalStakeSum',
  'totalTreasureAmount',
  'blocksHeight', //区块
  'totalStakeAndRegionNumtotalStakeSum',
]

export interface I_cardInfoItem {
  title: string
  num: number | string
  num1?: number | string
  icon: string
  key: string
  mecUnit?: boolean
  tip?: string
  noPercentile?: boolean
  needShowAll?: boolean
  originNum?: number | string
  className?: string
  hide?: boolean
}
const StatsBlockItem = ({
  cardInfo,
  noBorder = false,
  isValidator = false,
}: {
  cardInfo: I_cardInfoItem
  noBorder?: boolean
  isValidator?: boolean
}) => {
  const { t } = useTranslation()

  const getCusTitleActiveAddressCount = () => {
    return (
      <>
        <MeToolTip title={t('explorer_15')} tip={t('explorer_137')}></MeToolTip>
        <span style={{ margin: '0 2px' }}>{'/'}</span>
        {t('explorer_16')}
      </>
    )
  }

  return (
    <div
      style={{
        display: cardInfo.hide ? 'none' : 'flex',
      }}
      className={classNames({
        [Style.wrapContainer]: true,
        [Style.wrapContainerValidatorBox]: isValidator,
      })}
    >
      <div
        className={classNames(
          {
            [Style.wrap]: true,
            [Style.wrapNoBoder]: noBorder,
            [Style.wrapContainerValidator]: isValidator,
          },
          cardInfo.className,
        )}
      >
        <div>
          <div className={Style.title}>
            {cardInfo.key === 'activeAddressCount' ? (
              getCusTitleActiveAddressCount()
            ) : cardInfo.tip ? (
              <MeToolTip title={cardInfo.title} tip={cardInfo.tip}></MeToolTip>
            ) : (
              cardInfo.title
            )}
          </div>
          <div
            className={classNames({
              [Style.num]: true,
              [Style.numberStyleTwo]: cardInfo.num?.toString().length > 13,
              [Style.numberStyleOne]: cardInfo.num?.toString().length > 20,
            })}
          >
            {needScrollKey.includes(cardInfo.key) ? (
              isEmptyOrNil(cardInfo.num) || cardInfo.num === '-' ? (
                <span>{'-'}</span>
              ) : (
                <MeCountUp
                  end={cardInfo.num}
                  separator={cardInfo.noPercentile ? '' : ','}
                  showTooltip={cardInfo.needShowAll}
                  originNum={cardInfo.originNum}
                />
              )
            ) : (
              <>
                {' '}
                <span>{cardInfo.num || '-'}</span>
                {!isEmptyOrNil(cardInfo.num1) && <span>/{cardInfo.num1}</span>}
              </>
            )}
          </div>
        </div>
        {/* <img src={cardInfo.icon} alt="" /> */}
      </div>
    </div>
  )
}

export default StatsBlockItem
